export const deepEqual = (a?: any, b?: any): boolean => {
  if (a === b) return true

  if (typeof a !== typeof b) return false

  if (typeof a === 'object' && a !== null && b !== null) {
    const keysA = Object.keys(a)
    const keysB = Object.keys(b)

    if (keysA.length !== keysB.length) return false

    for (const key of keysA) {
      if (!deepEqual(a[key], b[key])) return false
    }
    return true
  }

  return false
}
